// Thư mục: src/services/xeService.js
import api from "@/api";

export const XeApi = {
  list({ q = "", page = 0, size = 10, sort = "id,desc" } = {}) {
    return api
      .get("/api/xe", { params: { q, page, size, sort } })
      .then((res) => res.data);
  },
  get(id) {
    return api.get(`/api/xe/${id}`).then((res) => res.data);
  },
  // API create/update nhận XeRequestDto (chứa loaiXeId)
  create(payload) {
    return api.post("/api/xe", payload).then((res) => res.data);
  },
  update(id, payload) {
    return api.put(`/api/xe/${id}`, payload).then((res) => res.data);
  },
  remove(id) {
    return api.delete(`/api/xe/${id}`).then((res) => res.data);
  },

  async getHanhTrinh(xeId) {
    const res = await api.get(`/api/xe/${xeId}/hanh-trinh`);
    return res.data;
  },
};
